import { reducers, MyStore } from 'kts-platform-frame/redux';
import { NodeEnvType } from 'kts-platform-frame/entry/constant';
import { consoleTestResultHandler } from 'tslint/lib/test';

const { env, config } = MyStore.instance.getState();

const NodeEnvTypeString = new Map<NodeEnvType, string>([
    [NodeEnvType.开发环境, 'dev.'],
    [NodeEnvType.测试环境, 'test.'],
    [NodeEnvType.演示环境, 'demo.'],
    [NodeEnvType.腾讯演示环境, 'tdemo.'],
    [NodeEnvType.生产环境, ''],
]);

/** 登录页面地址 */
export function loginUrl(): string {
    const loginURL = window.localStorage.getItem('$$/system/loginURL');
    if (loginURL) {
        return loginURL;
    } else {
        return '//login.{env}kingxunlian.com/'.replace('{env}', NodeEnvTypeString.get(env.NODE_ENV));
    }
}

/** 请求头（全局） */
export function serverDomain(): string {
    return config.rootConfig.API_URI.replace('{env}', NodeEnvTypeString.get(env.NODE_ENV));
}

/** 请求头（平台） */
export function serverPlatformDomain(): string {
    return config.rootConfig.PLATFORM_API_URI.replace('{env}', NodeEnvTypeString.get(env.NODE_ENV));
}

/** 媒体服务地址（全局） */
export function mediaUrl(): string {
    return config.rootConfig.MEDIA_URL;
}

/** socket 地址 */
export function socketUrl(): string {
    return config.rootConfig.SOCKET_URL.replace('{env}', NodeEnvTypeString.get(env.NODE_ENV));
}

/** app的启动地址(内部) */
export function appIndexUri(appid: string): string {
    const app = config.appList.map.get(appid);

    if (!app) {
        console.error('APP不存在，查看后端接口或者配置文件');
    }

    return app.URL
        .replace('{env}', NodeEnvTypeString.get(env.NODE_ENV))
        .replace('{domain}', config.rootConfig.APP_DOMAIN)
        ;
}



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/configUtils/index.ts